<template>
    <div class="form-group row">
        <label class="col-md-4 col-form-label text-md-right">Κείμενο Ανακοίνωσης *</label>
        <div class="col-md-6">
            <quill-editor
                v-model='content'
                :options="editorOption"
                @change="onContentChange($event)"
            />
        </div>
    </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import ImageResize from 'quill-image-resize-module'
import Quill from 'quill';

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Quill.register('modules/imageResize', ImageResize);

export default {
    name: 'Editor',
    components: {
        quillEditor
    },
    props:['oldContent'],
    data: function() {
        return {
            editorOption: {
                modules: {
                    imageResize: true,
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'font': [] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'align': [] }],
                        ['clean'],
                        ['link', 'image']
                    ]
                },
                theme: 'snow'
            },
            content: ''
        }
    },
    created() {
        this.content = this.$props.oldContent ? this.$props.oldContent : '';
    },
    methods: {
        onContentChange() {
            setTimeout(() => this.$emit('contentChanged', this.content), 1000);
        }
    }
}
</script>